import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { getImageUrl } from "../utils/imageHelper";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ---------- Custom Arrows ----------
const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute right-4 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white hover:text-black transition-all duration-300 group"
  >
    <IoChevronForward className="text-xl group-hover:scale-110 transition-transform" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute left-4 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white hover:text-black transition-all duration-300 group"
  >
    <IoChevronBack className="text-xl group-hover:scale-110 transition-transform" />
  </button>
);

const BannerCarousel = () => {
  const [banners, setBanners] = useState([]);

  const getBanners = async () => {
    try {
      const { data } = await axios.get("/api/v1/banner");

      if (data.success) {
        setBanners(data.banners);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getBanners();
  }, []);

  const settings = {
    dots: banners.length > 1,
    infinite: banners.length > 1,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: banners.length > 1,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    fade: true,
    cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
    arrows: banners.length > 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    customPaging: () => (
      <div className="w-2 h-2 mt-8 mx-1 rounded-full bg-white/40 hover:bg-white transition-all duration-300" />
    ),
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          bottom: "30px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ul className="flex gap-2">{dots}</ul>
      </div>
    ),
  };

  if (!banners.length) return null;

  return (
    <div className="relative w-full overflow-hidden bg-black group">
      <Slider {...settings} className="h-[60vh] md:h-[500px] lg:h-[600px]">
        {banners.map((banner) => (
          <div
            key={banner._id}
            className="relative h-[60vh] md:h-[500px] lg:h-[600px] outline-none focus:outline-none"
          >
            <div className="relative w-full h-full">
              <img
                src={getImageUrl(banner.image)}
                onError={(e) => {
                  e.target.src = "/images/fallback-RB.png";
                }}
                alt={banner.title}
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-black/25 flex items-center">
                <div className="max-w-7xl mx-auto w-full px-6 md:px-10">
                  {banner.title && (
                    <h1 className="text-white text-3xl md:text-5xl lg:text-6xl font-bold mb-4">
                      {banner.title}
                    </h1>
                  )}

                  {banner.subtitle && (
                    <p className="text-white text-lg md:text-2xl max-w-2xl mb-8">
                      {banner.subtitle}
                    </p>
                  )}

                  {banner.link && (
                    <Link
                      to={banner.link}
                      className="inline-flex items-center bg-white text-black px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
                    >
                      Shop Now
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <style>{`
        .slick-dots .slick-active div {
          background-color: #ffffff !important;
          transform: scale(1.2);
        }
      `}</style>
    </div>
  );
};

export default BannerCarousel;